export enum FormFieldWidth {
  RESPONSIVE_240 = "responsive-240",
  FULL = "full",
  CUSTOM = "custom"
}
